import clsx from "clsx"
import { useOpenModalCount } from "src/components/hooks/usePreventBodyScroll"
import { IntegrationScript } from "src/integrations/lib/IntegrationScript"

export function ReviewsIoFloatingWidget() {
  const openModalCount = useOpenModalCount()

  return (
    <>
      <div
        className={clsx(
          "reviews-io-floating-widget",
          openModalCount ? "opacity-0" : "opacity-100",
          "w-full transition-opacity",
        )}
        widget-id="nQYAvgI3q1O2RNyX"
        data-store-name="elvent.shop"
        lang="de"
      />

      <IntegrationScript id="reviewsio" src="https://widget.reviews.io/modern-widgets/floating.js" />
    </>
  )
}
